import { useRef, useEffect, useState } from "react";
import imagesLoaded from 'imagesloaded';

import {gsap} from 'gsap';
import { withTranslation } from 'react-i18next';
import Config from 'config/config.json';

import {getLocaleTag} from 'services/i18n.js';

import Buttons from "components/Buttons";

import s from "./NFT.module.scss";

import image1 from "./img/NFT1.png";
import image2 from "./img/NFT2.png";
import image3 from "./img/NFT3.png";
import image4 from "./img/NFT4.png";
import image5 from "./img/NFT5.png";
import image6 from "./img/NFT6.png";
import image7 from "./img/NFT7.png";

const NFT = ({t}) => {

  return (
    <>
      <div className={s.NFTwrapper}>
        <div className={s.NFToverlay}>
          <div className={s.NFTshop}>
            <div className={s.content}>
              <h2>{t('drop2_module6_hed')}</h2>
              <div className={s.txtContent}>
                <p>{t('drop2_module6_sub')}</p>
              </div>
              <div className={s.btnContent}>
              <Buttons
                data-analytics 
                data-action="click_cta" 
                data-label="click_shopwmn" 
                data-category="ecommerce"
                href={t('drop2_module6_CTA1_link')}
                width="80%"
                color="#000"
                background="#fff"
                border="1px solid #fff"
                children={t('drop2_module6_CTA1')}>
              </Buttons>
              <Buttons
                data-analytics 
                data-action="click_cta" 
                data-label="click_shopmen" 
                data-category="ecommerce"
                href={t('drop2_module6_CTA2_link')}
                width="80%"
                color="#fff"
                background="transparent"
                border="1px solid #fff"
                children={t('drop2_module6_CTA2')}>
              </Buttons>
              </div>
            </div>
          </div>
        </div>
        
        <div className={[s.NFTcolumn, s.ColumnLeft].join(' ')}>
          <div className={s.NFTrow}>
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image1} alt="" />
            <img src={image2} alt="" />
            <img src={image1} alt="" />
            <img src={image2} alt="" />
          </div>
        </div>
        <div className={[s.NFTcolumn, s.ColumnMiddle].join(' ')}>
          <div className={s.NFTrow}>
            <img src={image3} alt="" />
            <img src={image5} alt="" />
            <img src={image4} alt="" />
            <img src={image3} alt="" />
            <img src={image5} alt="" />
            <img src={image4} alt="" />
            <img src={image3} alt="" />
            <img src={image5} alt="" />
            <img src={image4} alt="" />
            <img src={image3} alt="" />
            <img src={image5} alt="" />
            <img src={image4} alt="" />
          </div>
        </div>
        <div className={[s.NFTcolumn, s.ColumnRight].join(' ')}>
          <div className={s.NFTrow}>
            <img src={image5} alt="" />
            <img src={image6} alt="" />
            <img src={image7} alt="" />
            <img src={image5} alt="" />
            <img src={image6} alt="" />
            <img src={image7} alt="" />
            <img src={image5} alt="" />
            <img src={image6} alt="" />
            <img src={image7} alt="" />
            <img src={image5} alt="" />
            <img src={image6} alt="" />
            <img src={image7} alt="" />
          </div>
        </div>
      </div>
      <div className={s.bottomWrap}></div>
    </>
  );
};

export default withTranslation()(NFT);
